/**
 * @overview 推荐管理
 * @author jzhu
 * @date 2020-9-23
 */

import React from 'react'
import {connect} from 'dva'
import {templateConfig, reduxTemplateCofig} from './config'
import {framework_tool, component_tool} from '@/tool'

let {WizContainer, WizReduxTemplate} = framework_tool
let {WizBrowserExport} = component_tool

const platforms = {
  'PC': 0,
  'APP': 1,
}

const positions = {
  '首页轮播': 0,
  '广告位': 1,
  '路径推荐位': 2,
  '任务推荐位': 3
}

class Featured extends WizContainer {

  componentName = 'Featured'

  constructor(props) {
    super(props)
    this.state = {}
  }

  _dict = (data) => {
    let dict = []
    for (let [key, value] of Object.entries(data)) {
      let item = {code: value, codeName: key}
      dict.push(item)
    }
    return dict
  }

  _columns = () => {
    let defaultProps = {
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: {vertical: 'bottom', horizontal: 'left'},
      }
    }
    return [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '关联内容',
        field: 'entityName',
        width: 25,
        ...defaultProps
      },
      {
        headerName: '关联类型',
        field: 'entityType',
        width: 15,
        ...defaultProps
      },
      {
        headerName: '发布平台',
        field: 'platforms',
        width: 20,
        ...defaultProps
      },
      {
        headerName: '推荐位',
        field: 'positions',
        width: 20,
        ...defaultProps
      },
      {
        headerName: '状态',
        field: 'state',
        width: 10,
        ...defaultProps
      },
      {
        headerName: '生效时间',
        field: 'startDate',
        width: 20,
        ...defaultProps
      },
      {
        headerName: '失效时间',
        field: 'endDate',
        width: 20,
        ...defaultProps
      }
    ]
  }

  _rows = (data) => {
    let rows = []
    let platformDict = this._dict(platforms)
    let positionDict = this._dict(positions)
    data && data.length && data.forEach(record => {
      let row = record
      let {entityType, state} = record
      switch (entityType) {
        case 0:
          row.entityType = '课程'
          break
        case 1:
          row.entityType = '考试'
          break
        // case 3:
        //     row.entityType = '直播'
        //     break
        case 15:
          row.entityType = '报名'
          break
        case 20:
          row.entityType = '公告'
          break
        // case 22:
        //   row.entityType = '话题'
        //   break
        // case 23:
        //   row.entityType = '活动'
        //   break
        case 25:
          row.entityType = '系列化课程'
          break;
        case 26:
          row.entityType = '直播'
          break
        case 37:
          row.entityType = '投票'
          break
        case 59:
          row.entityType = '练习'
          break
        default:
          row.entityType = ''
      }
      switch (state) {
        case 0:
          row.state = '草稿'
          break
        case 1:
          row.state = '打开'
          break
        case 2:
          row.state = '关闭'
          break
        case 3:
          row.state = '失效'
          break
        default:
          row.state = ''
      }
      row.platforms = record.platforms ? record.platforms.map(item => platformDict.filter(dic => dic.code === item).map(dic => dic.codeName)[0]).join(',') : ''
      row.positions = record.positions ? record.positions.map(item => positionDict.filter(dic => dic.code === item).map(dic => dic.codeName)[0]).join(',') : ''
      rows.push(row)
    })
    return rows
  }

  _export = (nextProps, nextState, key) => {
    let o = nextProps[key]
    if (o.success) {
      let columns = this._columns()
      let rows = this._rows(o.data)
      WizBrowserExport({
        title: '推荐管理',
        sheetName: '推荐管理',
        columns: columns.filter((_, index) => index),
        rows,
        filename: '推荐管理.xlsx',
      })
      return true
    } else {
      wizNotice.error(o.msg)
      return false
    }
  }

  _updateState = (nextProps, nextState, key) => {
    let o = nextProps[key]
    if (o.success) {
      wizNotice.success('操作成功')
    } else {
      wizNotice.error(o.msg)
    }
    return true
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig(this),
      apiDataFormat: {
        export: this._export,
        updateState: this._updateState
      }
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
}

export default connect(mapStateToProps)(Featured)
